import { createReportData } from "../../models/reportData.model";

export const accountingReportGetters = {
  reportData: (state) => createReportData(state.reportData),
}